import { Subscriptions } from '@mui/icons-material';
import { Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';

const VideoButton = React.forwardRef<HTMLDivElement>((props, ref) => {
  const navigate = useNavigate();

  return (
    <Box
      {...props}
      ref={ref}
      sx={{
        backgroundImage:
          'linear-gradient(93deg, #47A3E6 -4.64%, #54CEE9 101.13%)',
        position: 'fixed',
        zIndex: 999,
        width: '42px',
        height: '42px',
        bottom: '60px',
        right: '20px',
        borderRadius: '100%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onClick={() => navigate('/guide/video_tutorial')}
      component="div"
    >
      <Subscriptions htmlColor="white" />
    </Box>
  );
});

VideoButton.displayName = 'VideoButton';

export default VideoButton;
